<template>
    <div class="tw-flex tw-flex-col tw-w-full tw-px-0 lg:tw-px-6 main-body-p">
        <div class="tw-flex tw-flex-col lg:tw-flex-row tw-pt-3 lg:tw-pt-6 tw-pb-12 tw-border-0 md:tw-border-t md:tw-border-b md:tw-border-dark-grey">
            <div class="tw-flex tw-flex-col tw-w-full tw-border-b tw-border-dark-grey md:tw-border-0">
                <div class="tw-flex tw-flex-col md:tw-flex-row tw-justify-between">
                    <div>
                        <div class="tw-flex tw-flex-col tw-font-light tw-pb-3 sm:tw-pb-1">
                            <div class="tw-text-4xl tw-uppercase" v-if="!!user">{{ user.first_name }} {{ user.last_name }}</div>
                            <h6>{{ user.category }}</h6>
                        </div>
                        <div class="tw-flex tw-flex-col tw-gap-2">
                            <member-profile-info-item
                                v-for="(profile_info_item, profile_info_item_index) of profile_info"
                                :key="profile_info_item_index"
                                :text="profile_info_item_index"
                                :value="profile_info_item"
                            />
                        </div>
                    </div>
                    <div class="tw-flex tw-flex-col tw-my-4 md:tw-my-0 tw-w-full md:tw-w-64 tw-justify-center tw-items-center tw-border tw-border-dark-grey tw-p-10">
                        <h5>Dues</h5>
                        <h4 class="tw-font-normal" :class="[ user.dues_balance > 0 ? 'tw-text-red-600' : 'tw-text-green-600' ]">{{ $root.formatCurrency(this.user.dues_balance) }}</h4>
                        <div class="tw-flex tw-flex-col tw-items-center tw-justify-center">
                            <p class="tw-text-sm mb-0">{{ user.dues_balance > 0 ? 'Balance Due' : 'CREDIT Balance' }}</p>
                            <p class="tw-text-sm mb-2">{{ user.dues_balance > 0 ? 'Please Pay Now' : 'NO Dues Owing' }}</p>
                        </div>

                        <button type="button" class="main-btn" @click="goToBambora">Pay Dues Now</button>
                    </div>
                    <member-profile-info-item
                        v-for="(profile_info_item, profile_info_item_index) of profile_info"
                        :key="profile_info_item_index"
                        :text="profile_info_item_index"
                        :value="profile_info_item"
                        class="tw-hidden"
                    />
                </div>
            </div>
        </div>
        <div class="tw-flex tw-flex-col md:tw-flex-row">
            <v-btn class="main-btn tw-mx-auto tw-my-3" @click="dialog_profile_change = true">Update Profile</v-btn>
            <v-btn class="main-btn tw-mx-auto tw-my-3" @click="dialog_gender_change = true">Update Self-Identifiers</v-btn>
            <v-btn class="main-btn tw-mx-auto tw-my-3" @click="dialog_resume_change = true" v-if="!is_producer">Update Resume</v-btn>
            <v-btn class="main-btn tw-mx-auto tw-my-3" @click="dialog_password_change = true">Update Password</v-btn>
        </div>

        <v-dialog
            v-model="dialog_profile_change"
            fullscreen
            transition="dialog-bottom-transition"
            scrollable
        >
            <div class="tw-flex tw-flex-col tw-text-center tw-text-black">
                <h4 class="tw-py-2">Profile Change</h4>
                <div class="tw-flex tw-flex-col tw-w-full tw-px-5 md:tw-px-10">
                    <div class="tw-text-lg tw-pb-4 tw-font-light">
                        Please enter your updated profile information below in as much detail as possible and click submit.
                        <br>
                        A staff member will review your details prior to updating the site.
                    </div>
                    <v-form
                        v-model="form_profile_change_is_valid"
                        ref="form_profile_change"
                        v-on:submit.prevent
                    >
                        <div class="tw-py-4 tw-w-full md:tw-w-1/2 tw-m-auto">
                            <v-textarea
                                v-model="profile_change"
                                :error-messages="errors?.profile_change"
                                :rules="[rules.required]"
                                label="Enter your changes here"
                                auto-grow
                                outlined
                            ></v-textarea>
                        </div>
                        <div class="tw-py-4">
                            <v-btn @click="dialog_profile_change = false" class="main-btn tw-w-36 tw-mx-auto tw-my-3">
                                Cancel
                            </v-btn>
                            <v-btn
                                @click="submitProfileChange"
                                class="main-btn"
                                :disabled="!form_profile_change_is_valid"
                            >
                                Submit
                            </v-btn>
                        </div>
                    </v-form>
                </div>

            </div>
        </v-dialog>
        <v-dialog
            v-model="dialog_password_change"
            fullscreen
            transition="dialog-bottom-transition"
            scrollable
        >
            <div class="tw-flex tw-flex-col tw-text-center tw-text-black">
                <h4 class="tw-py-2">Password Update</h4>
                <div class="tw-flex tw-flex-col tw-w-full tw-px-5 md:tw-px-10">
                    <div class="tw-text-lg tw-pb-4 tw-font-light">
                        If you have forgotten your password, or need a new one please contact I.A.T.S.E. Local 667 office at: <br>
                        <a href="mailto:camera@iatse667.com" class="tw-font-normal">camera@iatse667.com</a>, or <a href="tel:416-368-0072" class="tw-font-normal">416-368-0072</a> or toll free at <a href="tel:1-877-368-1667">1-877-368-1667</a> in eastern Canada only.
                        <br>
                        Please allow one business day for the office to respond.
                    </div>
                    <v-form
                        v-model="form_pw_update_is_valid"
                        ref="form_pw_update"
                        v-on:submit.prevent
                    >
                        <div class="tw-w-full lg:tw-w-1/2 tw-gap-4 tw-pb-4 tw-mx-auto">
                            <v-text-field
                                v-model="pw_current"
                                :error-messages="errors?.password_current"
                                :rules="[rules.required]"
                                label="Your current password"
                                outlined
                                dense
                                clearable
                                type="password"
                            />
                            <v-text-field
                                v-model="pw_new"
                                :error-messages="errors?.password"
                                :rules="password_rules"
                                label="Your new password"
                                outlined
                                dense
                                clearable
                                type="password"
                            />
                            <v-text-field
                                v-model="pw_confirm"
                                :error-messages="errors?.password_confirmation"
                                :rules="[...password_rules, rules.match_new_pw]"
                                label="Confirm new password"
                                outlined
                                dense
                                clearable
                                type="password"
                            />
                            <v-btn @click="dialog_password_change = false" class="main-btn tw-w-36 tw-mx-auto tw-my-3">
                                Close
                            </v-btn>
                            <v-btn
                                @click="submitPasswordUpdate"
                                class="main-btn"
                                :disabled="!form_pw_update_is_valid"
                            >
                                Submit
                            </v-btn>
                        </div>

                    </v-form>
                </div>

            </div>
        </v-dialog>
        <v-dialog
            v-model="dialog_resume_change"
            fullscreen
            transition="dialog-bottom-transition"
            scrollable
        >
            <div class="tw-flex tw-flex-col tw-text-center tw-text-black">
                <h4 class="py-2">Resume Update</h4>
                <div class="tw-flex tw-flex-col tw-w-full md:tw-w-1/2 tw-px-4 md:tw-px-10 tw-mx-auto">
                    <div class="tw-text-lg tw-pb-4 tw-font-light">
                        Please enter your updated resume information below in as much detail as possible and click submit.
                        A staff member will review your details prior to updating the site.                    </div>
                    <v-form
                        v-model="form_resume_update_is_valid"
                        ref="form_resume_update"
                        v-on:submit.prevent
                    >
                        <div class="tw-py-4">
                            <v-textarea
                                v-model="resume_text"
                                :error-messages="errors?.resume_text"
                                :rules="resume_rules"
                                label="Enter your changes here"
                                auto-grow
                                outlined
                            ></v-textarea>
                            <br/>
                            - OR -
                            <br/>

                            <v-file-input
                                v-model="resume_file"
                                label="Attach your resume here"
                                :error-messages="errors?.resume_file"
                                :rules="resume_rules"
                                dense
                                outlined
                                :prepend-icon="null"
                            >
                            </v-file-input>
                        </div>

                        <div class="tw-py-4">
                            <v-btn @click="dialog_resume_change = false" class="main-btn tw-w-36 tw-mx-auto tw-my-3">
                                Close
                            </v-btn>
                            <v-btn
                                @click="submitResumeChange"
                                class="main-btn"
                                :disabled="!form_resume_update_is_valid"
                            >
                                Submit
                            </v-btn>
                        </div>
                    </v-form>
                </div>
            </div>
        </v-dialog>
        <v-dialog
            v-model="dialog_gender_change"
            fullscreen
            transition="dialog-bottom-transition"
            scrollable
        >
            <div class="tw-flex tw-flex-col tw-text-center tw-text-black tw-px-4 md:tw-px-0">
                <h4 class="pb-2">Self Identification</h4>
                <div class="tw-flex tw-flex-col tw-w-full">
                    <div class="tw-text-lg tw-pb-4 tw-w-full md:tw-w-1/2 tw-mx-auto tw-font-light">
                        <p>With our Local’s mandate to continually improve the services we offer to the membership, we have
                            introduced a voluntary self-service member’s area for individual identification and preference selection
                            such as pronouns, gender identities, ethnicities, etc.</p>

                        <p>The Information you choose to provide will not be visible to anyone else using the site unless you select
                            a specific option in the “approvals” portion of the dropdowns. These are categories we intend to use
                            internally to focus our initiatives for training, health, and social offerings to our members. All answers
                            are voluntary and are intended to create a clearer picture as to the personality of our Local.</p>

                        <p>If there is a section that you do not wish to answer, please feel free to leave it empty.</p>

                        <p>Please reach out to the office, should you have any questions regarding the
                            identifiers listed.</p>
                    </div>
                    <v-form
                        v-model="form_self_identification"
                        ref="form_self_identification"
                        v-on:submit.prevent
                    >
                        <div class="tw-flex tw-flex-col tw-w-full tw-mx-auto md:tw-w-1/2 md:tw-flex-row tw-py-4 tw-gap-4">
                            <div class="tw-w-full">
                                <v-autocomplete
                                    v-model="identification_genders"
                                    :items="valuelists.GENDERS"
                                    label="Gender"
                                    hide-details="auto"
                                    :menu-props="{top: true}"
                                    multiple
                                    dense
                                    reactive
                                    outlined
                                    clearable
                                ></v-autocomplete>
                                <v-text-field
                                    v-if="isOtherSelected(identification_genders, valuelists.GENDERS)"
                                    v-model="identification_genders_other"
                                    label="Other Gender"
                                    class="pt-2"
                                    hide-details="auto"
                                    outlined
                                    dense
                                    clearable
                                />
                            </div>
                            <div class="tw-w-full">
                                <v-autocomplete
                                    v-model="identification_pronouns"
                                    :items="valuelists.PRONOUNS"
                                    label="Pronouns"
                                    hide-details="auto"
                                    :menu-props="{top: true}"
                                    multiple
                                    dense
                                    reactive
                                    outlined
                                    clearable
                                ></v-autocomplete>
                                <v-text-field
                                    v-if="isOtherSelected(identification_pronouns, valuelists.PRONOUNS)"
                                    v-model="identification_pronouns_other"
                                    label="Other Pronoun"
                                    class="pt-2"
                                    hide-details="auto"
                                    outlined
                                    dense
                                    clearable
                                />
                            </div>
                            <div class="tw-w-full">
                                <v-autocomplete
                                    v-model="identification_racial_categories"
                                    :items="valuelists.RACIAL_CATEGORIES"
                                    label="Racial Categories"
                                    hide-details="auto"
                                    :menu-props="{top: true}"
                                    multiple
                                    dense
                                    reactive
                                    outlined
                                    clearable
                                ></v-autocomplete>
                                <v-text-field
                                    v-if="isOtherSelected(identification_racial_categories, valuelists.RACIAL_CATEGORIES)"
                                    v-model="identification_racial_categories_other"
                                    label="Other Racial Category"
                                    class="pt-2"
                                    hide-details="auto"
                                    outlined
                                    dense
                                    clearable
                                />
                            </div>
                        </div>
                        <div class="tw-pb-2 tw-flex tw-flex-col md:tw-flex-row tw-gap-2 md:tw-w-1/2 tw-mx-auto">
                            <v-select
                                v-model="identification_lgbt_identifying"
                                :items="getLgbtOptions"
                                label="Do you identify as LGBTQIA2S+"
                                class="tw-w-full"
                                :menu-props="{top: true, offsetY: true}"
                                outlined
                                dense
                                open-on-clear
                                clearable
                                hide-details="auto"
                            />
                            <v-text-field
                                v-if="identification_lgbt_identifying === 'Other'"
                                v-model="identification_lgbt_identifying_as"
                                label="Other"
                                hide-details="auto"
                                class="tw-w-full"
                                outlined
                                dense
                                clearable
                            />
                            <v-text-field
                                v-if="identification_lgbt_identifying === 'Yes'"
                                v-model="identification_lgbt_identifying_as"
                                label="How do you wish to be identified?"
                                hide-details="auto"
                                class="tw-w-full"
                                outlined
                                dense
                                clearable
                            />
                        </div>
                        <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-2 md:tw-w-1/2 tw-mx-auto">
                            <v-autocomplete
                                v-model="identification_marital_statuses"
                                :items="valuelists.MARITAL_STATUSES"
                                label="Marital Status"
                                hide-details="auto"
                                class="tw-w-full"
                                :menu-props="{top: true}"
                                multiple
                                dense
                                reactive
                                outlined
                                clearable
                            ></v-autocomplete>
                            <v-text-field
                                v-if="isOtherSelected(identification_marital_statuses, valuelists.MARITAL_STATUSES)"
                                v-model="identification_marital_statuses_other"
                                label="Other Marital Status"
                                hide-details="auto"
                                class="tw-w-full"
                                outlined
                                dense
                                clearable
                            />
                        </div>
                        <div class="tw-w-full md:tw-w-1/2 tw-mt-6 tw-mb-2 tw-mx-auto">
                            <h4 class="tw-font-light">Please fill this out, or answer it.</h4>
                            <v-autocomplete
                                v-model="identification_identification_usage_consents"
                                :items="valuelists.IDENTIFICATION_USAGES"
                                label="Approvals"
                                hide-details="auto"
                                dense
                                reactive
                                outlined
                                clearable
                            ></v-autocomplete>
                        </div>

                        <v-btn @click="dialog_gender_change = false" class="main-btn tw-w-36 tw-mx-auto tw-my-3">
                            Close
                        </v-btn>
                        <v-btn
                            @click="submitIdentityChange"
                            class="main-btn"
                        >
                            Submit
                        </v-btn>
                    </v-form>
                </div>

            </div>
        </v-dialog>
        <div v-if="!is_producer" class="tw-flex tw-flex-col tw-text-xl md:tw-flex-row tw-px-0 md:tw-px-6 tw-pt-6 tw-pb-12 tw-border-0 md:tw-border-t md:tw-border-b md:tw-border-dark-grey">
            <div class="tw-flex tw-flex-col tw-w-full xl:tw-w-5/6 tw-border-b tw-border-dark-grey md:tw-border-0">
                <div class="tw-py-4">You currently show up on the listing with availability of: {{ current_availability_status }}</div>
                <div class="tw-py-4">
                    We keep a record of all the productions you're involved in, and will update your availability accordingly.
                    Dates we know you're unavailable for are listed here.
                </div>

                <div class="tw-flex tw-flex-col md:tw-flex-row tw-w-full tw-py-1">
                    <div class="tw-uppercase">
                        <v-date-picker
                            :value="member_availability"
                            :events="member_availability"
                            :event-color="getEventColors"
                            scrollable
                            multiple
                            :selected-items-text="`${member_availability?.length} day${member_availability?.length ? 's' : ''}`"
                            no-title
                        >

                        </v-date-picker></div>
                    <div class="tw-w-full tw-pl-5">
                        Upcoming Availability Exceptions
                        <smart-table :headers="headers_upcoming_events" :items="user.availability_upcoming"></smart-table>
                    </div>

                </div>

                <br/>
                <div>
                    Let us know if there are other dates you'll be unavailable for.  Include any pertinent details.
                    By submitting them, we will receive an email, and will update your availability accordingly.
                </div>

                <v-form
                    v-model="form_availability_is_valid"
                    ref="form_availability"
                    v-on:submit.prevent
                >
                    <div class="tw-py-4">
                        <v-textarea
                            v-model="availability_change"
                            :error-messages="errors?.availability_change"
                            :rules="[rules.required]"
                            label="Enter your availability updates here"
                            auto-grow
                            outlined
                        ></v-textarea>
                    </div>

                    <div class="tw-py-4">
                        <v-btn
                            @click="submitAvailabilityChange"
                            class="main-btn"
                            :disabled="!form_availability_is_valid"
                        >
                            Submit
                        </v-btn>
                    </div>
                </v-form>


            </div>

        </div>

    </div>
</template>

<script>
import InternalHeader from "@/Generic/InternalHeader";
import MemberProfileInfoItem from "@/Pages/InternalPages/MemberProfile/MemberProfileInfoItem.vue";
import SmartNav from "@/SmartNav/SmartNav.vue";
import SmartNavSidebar from "@/SmartNav/SmartNavSidebar.vue";
import AppLayoutSidebarNav from "@/Layouts/AppLayoutSidebarNav.vue";
import SmartTable from "@/Generic/SmartTable.vue";

export default {
        name: "MemberProfileIndex",
        layout: (h, page) => {
            return h(AppLayoutSidebarNav, [
                page
            ])
        },
        components: {
            SmartTable,
            SmartNavSidebar,
            SmartNav,
            MemberProfileInfoItem,
            InternalHeader,
        },
        props: {
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'valuelists': {
                type: Object,
                required: true,                     // we require VL_CLASSIFICATIONS
                default: function () {
                    return undefined
                }
            },
            'item': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
        },
        data() {
            return {
                bambora_link: null,
                data_prop: null,
                dates_selected: null,
                errors: null,
                availability_change: null,
                profile_change: null,
                resume_text: null,
                resume_file: null,
                pw_current: null,
                pw_new: null,
                pw_confirm: null,
                dialog_profile_change: false,
                dialog_password_change: false,
                dialog_resume_change: false,
                dialog_gender_change: false,
                form_pw_update_is_valid: false,
                form_availability_is_valid: false,
                form_profile_change_is_valid: false,
                form_resume_update_is_valid: false,
                form_self_identification: false,
                identification_pronouns: this.item?.pronouns?.map(record => record.id),
                identification_pronouns_other: this.getOtherValue(this.valuelists?.PRONOUNS, this.item?.pronouns),
                identification_genders: this.item?.genders?.map(record => record.id),
                identification_genders_other: this.getOtherValue(this.valuelists?.GENDERS, this.item?.genders),
                identification_racial_categories: this.item?.racial_categories?.map(record => record.id),
                identification_racial_categories_other: this.getOtherValue(this.valuelists?.RACIAL_CATEGORIES, this.item?.racial_categories),
                identification_marital_statuses: this.item?.marital_statuses?.map(record => record.id),
                identification_marital_statuses_other : this.getOtherValue(this.valuelists?.MARITAL_STATUSES, this.item?.marital_statuses),
                identification_identification_usage_consents: this.item?.identification_usage_consent_id,
                identification_lgbt_identifying: this.item?.lgbt_identifying,
                identification_lgbt_identifying_as: this.item?.lgbt_identifying_as,
                rules: {
                    required: value => !!value || 'Required',
                    min: (value) => value && (value.length >= 8) || 'Min 8 characters',
                    match_new_pw: value => value === this.pw_new || 'Passwords do not match',
                },
                password_rules: [
                    (value) => !!value || 'Please enter a password.',
                    (value) => (value && /[a-z]/.test(value)) || 'At least one lowercase letter',
                    (value) => (value && /[A-Z]/.test(value)) || 'At least one capital letter',
                    (value) => (value && /\d/.test(value)) || 'At least one number',
                    (value) => (value && value.length >= 8 ) || 'At least 8 characters',
                ],
                resume_rules: [
                    (value) => !!this.resume_text || !!this.resume_file || 'At least one field must be filled'
                ],
                filters_upcoming_events: {
                    date_start: null,
                    is_available: null,
                    production: null,
                },
            }
        },
        mounted() {
            //
        },
        computed: {
            user() {
                return !!this.item ? this.item : this.$root.$page.user
            },
            is_producer() {
                return this.$root.getUserRole() === this.constants?.USER_ROLES?.ROLE_PRODUCER
            },
            profile_info() {
                let list = {}
                if (this.is_producer) {
                    list = {
                        "address":          (Array.isArray(this.user?.addresses) && this.user.addresses.length) ? this.user.addresses[0].single_line_mailing_address : null,
                        "phone":            this.profileInfoForArrays(this.user?.telephones, 'telephone_fax'),
                        "email":            this.profileInfoForArrays(this.user?.emails, 'email'),
                        "website":          this.user?.website,
                        "category":         this.profileInfoForArrays(this.user?.functions, 'function_name'),
                    }
                } else {
                     list = {
                        "status":           this.user?.status?.classification_name,
                        "address":          (Array.isArray(this.user?.addresses) && this.user.addresses.length) ? this.user.addresses[0].single_line_mailing_address : null,
                        "phone":            this.profileInfoForArrays(this.user?.telephones, 'telephone_fax'),
                        "email":            this.profileInfoForArrays(this.user?.emails, 'email'),
                        "demo reel":        this.user?.demo_reel,
                        "website":          this.user?.website,
                        "resume":           (Array.isArray(this.user?.cvs) && this.user.cvs.length) ? this.profileInfoForArrays(this.user?.cvs[0]?.items, 'production_name') : null,
                        "dues":             this.profileInfoForArrays(this.user?.dues, 'null'),
                        "category":         this.profileInfoForArrays(this.user?.functions, 'function_name'),
                        "special skills":   this.profileInfoForArrays(this.user?.skills, 'skill_name'),
                    }
                }
                if (this.user?.mentor) {
                    list.mentor = (this.user?.mentor_note) ? this.generateCategoriesList(this.user?.functions_active) + ' (' + this.user?.mentor_note + ')' : this.generateCategoriesList(this.user?.functions_active)
                }
                return list
            },
            headers_upcoming_events() {
                return [
                    {value: 'display_name',                 text: 'Name',     align: `start`,  sortable: true,     filterable: true,   search: this?.filters?.production  },
                    {value: 'display_date_range',           text: 'Date(s)',  align: `start`,  sortable: true,     filterable: true,   search: this?.filters?.date_start  },
                ]
            },
            member_availability() {
                if (!this.user?.availability_upcoming?.length) {
                    return []
                }
                return this.user.availability_upcoming.reduce((acc, curr) => {
                    curr.all_dates.forEach(single_date => acc.push(single_date.split("T")[0]))
                    return acc
                }, [])
            },
            override_dates() {
                let filtered = this.user?.availability_upcoming?.filter(avail => avail.is_override)
                let timestamped = filtered.reduce((acc, curr)=> {
                    return acc.concat(curr.all_dates)
                }, [])
                return timestamped.map(timestamp => (timestamp.split("T")[0]))
            },
            production_dates() {
                let filtered = this.user?.availability_upcoming?.filter(avail => avail.production)
                let timestamped = filtered.reduce((acc, curr)=> {
                    return acc.concat(curr.all_dates)
                }, [])
                return timestamped.map(timestamp => (timestamp.split("T")[0]))
            },
            current_availability_status() {
                return this?.item?.availability_info
            },
            getLgbtOptions() {
                return Object.values(this.constants.USER_LGBT)
            }
        },
        methods: {
            // Carousels
            lineSeparatedListFromArray(data_array, prop_name) {
                console.log("Now running exampleMethod...")
            },
            profileInfoForArrays(data_array, prop_name) {
                if (!data_array || !Array.isArray(data_array) || (Array.isArray(data_array) && data_array.length === 0)) return null
                return data_array.map(element => element[prop_name]).filter(element=>element)
            },
            resetValidationProfileChange () {
                if (this.$refs && this.$refs.form_profile_change) {
                    this.$refs.form_profile_change.resetValidation()
                }
                if (this.errors) {
                    this.errors.profile_change = null
                }
            },
            resetValidationResetPw () {
                if (this.$refs && this.$refs.form_pw_update) {
                    this.$refs.form_pw_update.resetValidation()
                }
                if (this.errors) {
                    this.errors.password_current = null
                    this.errors.password = null
                    this.errors.password_confirmation = null
                }
            },
            resetValidationResumeUpdate () {
                if (this.$refs && this.$refs.form_resume_update) {
                    this.$refs.form_resume_update.resetValidation()
                }
                if (this.errors) {
                    this.errors.resume_text = null
                    this.errors.resume_file = null
                }
            },
            submitAvailabilityChange() {
                let payload = {
                    availability_change: this.availability_change
                }

                axios.post(route('change.availability'), payload)
                    .then(response => {
                        if( response.data && response.data.success) {
                            this.$root.snackbar.success("Your availability change request has been sent successfully")
                        } else {
                            let message = response.data.message || "Error sending availability change request"
                            this.$root.snackbar.error(message)
                        }
                    })
                    .catch((error) => {
                        if( error?.response ) {
                            this.$root.snackbar.error(error.response.data.message)
                            this.errors = error.response?.data?.errors
                        } else {
                            this.$root.snackbar.error(error)
                        }
                    })

            },
            submitProfileChange() {
                let payload = {
                    profile_change: this.profile_change
                }

                axios.post(route('change.profile'), payload)
                    .then(response => {
                        if( response.data && response.data.success) {
                            this.$root.snackbar.success("Your profile change request has been sent successfully")
                        } else {
                            let message = response.data.message || "Error sending profile change request"
                            this.$root.snackbar.error(message)
                        }
                    })
                    .catch((error) => {
                        if( error?.response ) {
                            this.$root.snackbar.error(error.response.data.message)
                            this.errors = error.response?.data?.errors
                        } else {
                            this.$root.snackbar.error(error)
                        }
                    })

            },
            submitPasswordUpdate() {
                let payload = {
                    password_current: this.pw_current,
                    password: this.pw_new,
                    password_confirmation: this.pw_confirm,
                }

                axios.post(route('change.password'), payload)
                    .then(response => {
                        if( response.data && response.data.message) {
                            this.$root.snackbar.success("Your password has been updated successfully")

                            // Wait 1 second, then let them know they are getting logged-out
                            setTimeout(() => {
                                this.$root.snackbar.warning("You will be logged-out momentarily")

                                // Wait 1 second, then redirect the user
                                setTimeout(()=>{
                                    window.location.href = route('home').url()
                                }, 2000)
                            }, 2000)
                        }
                    })
                    .catch((error) => {
                        if( error?.response ) {
                            this.$root.snackbar.error(error.response.data.message)
                            this.errors = error.response?.data?.errors
                        } else {
                            this.$root.snackbar.error(error)
                        }
                    })

            },
            submitResumeChange() {

                let payload = new FormData()

                if (!!this.resume_text){
                    payload.append("resume_text", this.resume_text)
                }
                if( this.resume_file ) {
                    payload.append("resume_file", this.resume_file)
                }


                axios.post(route('change.resume'), payload)
                    .then(response => {
                        if( response.data && response.data.success) {
                            this.$root.snackbar.success("Your resume change request has been sent successfully")
                        } else {
                            let message = response.data.message || "Error sending resume change request"
                            this.$root.snackbar.error(message)
                        }
                    })
                    .catch((error) => {
                        if( error?.response ) {
                            this.$root.snackbar.error(error.response.data.message)
                            this.errors = error.response?.data?.errors
                        } else {
                            this.$root.snackbar.error(error)
                        }
                    })

            },
            submitIdentityChange() {
                let payload = {
                    id: this.item.id,
                    genders: this.identification_genders,
                    genders_other: this.identification_genders_other,
                    marital_statuses: this.identification_marital_statuses,
                    marital_statuses_other: this.identification_marital_statuses_other,
                    pronouns: this.identification_pronouns,
                    pronouns_other: this.identification_pronouns_other,
                    racial_categories: this.identification_racial_categories,
                    racial_categories_other: this.identification_racial_categories_other,
                    identification_usage_consents: this.identification_identification_usage_consents,
                    lgbt_identifying: this.identification_lgbt_identifying,
                    lgbt_identifying_as: this.identification_lgbt_identifying_as,
                }

                axios.post(route('profile.update', this.item.id), payload)
                    .then(response => {
                        if( response.data && response.data.success) {
                            this.$root.snackbar.success("Your identity details have been updated successfully")
                            this.$inertia.reload({only: ['item']})

                        }
                    })
                    .catch((error) => {
                        if( error?.response ) {
                            this.$root.snackbar.error(error.response.data.message)
                            this.errors = error.response?.data?.errors
                        } else {
                            this.$root.snackbar.error(error)
                        }
                    })

            },
            getAvailabilityName(availability) {
                return availability?.display_name
            },
            getEventColors(date) {
                let colors = []

                if (this.override_dates.includes(date)) {
                    colors.push("FAIL")
                }
                if (this.production_dates.includes(date)) {
                    colors.push("PASS")
                }
                // return colors
                return false
            },
            generateCategoriesList(object) {
                let list = object.map(obj => (obj.title_function.abbreviation) ? obj.title_function.abbreviation : obj.title_function.name)
                let listWithoutDuplicates = [...new Set(list)]
                return listWithoutDuplicates.join(', ')
            },
            goToBambora() {
                try {
                    if (this.bambora_link) {
                        window.location.href = this.bambora_link
                    } else {
                        axios.get(route('bambora.link').url())
                            .then(response => {
                                this.bambora_link = response.data
                                this.$root.snackbar?.success("Redirecting to Bambora Checkout")
                                setTimeout(() => {
                                    window.location.href = this.bambora_link
                                }, 1000)
                            })
                            .catch(error => {
                                console.log("Error retrieving link to Bambora Checkout")
                                this.$root.snackbar?.error("Error retrieving link to Bambora Checkout")
                            })
                    }
                } catch ($ex) {
                    console.log($ex)
                }
            },
            isOtherSelected(listSelected, list) {
                return listSelected.some(value => list.some(item => item.value === value && item.text === "Other"));
            },
            getOtherValue(valueList, list) {
                let otherId = valueList.find(item => item.text === "Other").value
                let otherRecord = list.find(item => item.id === otherId)
                return otherRecord?.pivot?.other
            },
        },

        watch: {
            profile_change: {
                handler(newVal, oldVal) {
                    this.resetValidationProfileChange()
                }
            },
            pw_current: {
                handler(newVal, oldVal) {
                    this.resetValidationResetPw()
                }
            },
            pw_new: {
                handler(newVal, oldVal) {
                    this.resetValidationResetPw()
                }
            },
            pw_confirm: {
                handler(newVal, oldVal) {
                    this.resetValidationResetPw()
                }
            },
            resume_text: {
                handler(newVal, oldVal) {
                    this.resetValidationResumeUpdate()
                }
            },
            resume_file: {
                handler(newVal, oldVal) {
                    this.resetValidationResumeUpdate()
                }
            },
            dialog_gender_change: {
                handler(newVal, oldVal) {
                    this.identification_pronouns = this.item?.pronouns?.map(record => record.id)
                    this.identification_pronouns_other = this.getOtherValue(this.valuelists.PRONOUNS, this.item?.pronouns)
                    this.identification_genders = this.item?.genders?.map(record => record.id)
                    this.identification_genders_other = this.getOtherValue(this.valuelists.GENDERS, this.item?.genders)
                    this.identification_racial_categories = this.item?.racial_categories?.map(record => record.id)
                    this.identification_racial_categories_other = this.getOtherValue(this.valuelists.RACIAL_CATEGORIES, this.item?.racial_categories)
                    this.identification_marital_statuses = this.item?.marital_statuses?.map(record => record.id)
                    this.identification_marital_statuses_other = this.getOtherValue(this.valuelists.MARITAL_STATUSES, this.item?.marital_statuses)
                    this.identification_identification_usage_consents = this.item?.identification_usage_consent_id
                    this.identification_lgbt_identifying = this.item?.lgbt_identifying
                    this.identification_lgbt_identifying_as = this.item?.lgbt_identifying_as
                }
            },
            identification_lgbt_identifying: {
                handler(newVal, oldVal) {
                    this.identification_lgbt_identifying_as = '';
                }
            }
        }
    }
</script>
